import { Component, inject, input } from '@angular/core';

import { defer } from 'rxjs';

import { CamTenantUrlDisplayerComponent } from '../../../../common/components/tenant-url-displayer/tenant-url-displayer.component';
import { CamMaintenancesService } from '../../services/maintenances.service';

@Component({
  imports: [CamTenantUrlDisplayerComponent],
  selector: 'cam-maintenance-tenant-url-displayer',
  templateUrl: './maintenance-tenant-url-displayer.component.html',
})
export class CamMaintenanceTenantUrlDisplayerComponent {
  private _maintenancesService = inject(CamMaintenancesService);

  maintenanceId = input.required<string>();

  display = input<'button' | 'icon'>('icon');

  route$ = this._maintenancesService.tenantRoute.get$();

  fetch$ = defer(() => this._maintenancesService.fetchTenantRoute$(this.maintenanceId()));
}
